/**
 * Plan decisions read back from storage — shared, dependency-free.
 *
 * The planning engine's decision strings are stored as text (plan_records,
 * plan version payloads, saved planning runs). When one is renamed the stored
 * rows keep the old spelling — they are the record of what was said then — so
 * every reader maps the old text to today's word here. The in-app readers
 * (src/lib/planningStoredDecisions.ts) and the public decision-lineage route
 * (via planDecisionTrailCore.ts) both use this one table, so they cannot drift.
 *
 * 2026-10-28 (owner): "Deferred - Capacity" became "Out - capacity". "Deferred"
 * belongs to a person's triage choice; the engine reports a condition it found.
 *
 * Add a line here when a decision string is renamed. Do not edit stored rows
 * and do not compare against an old spelling anywhere else.
 */

/** Old stored spelling → the word it reads as now. */
export const RENAMED_PLAN_DECISIONS: Readonly<Record<string, string>> = {
  'Deferred - Capacity': 'Out - capacity',
};

/** One stored decision string, in today's words. Anything not renamed passes through. */
export function readStoredPlanDecision<T extends string | null | undefined>(stored: T): T {
  if (typeof stored !== 'string') return stored;
  return (RENAMED_PLAN_DECISIONS[stored] ?? stored) as T;
}
